import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useRef } from 'preact/compat';
import Notice from '@widgets/shared/components/Notice';
import { Content, Title, DiscountList, DiscountItem, DiscountIcon, DiscountTitle, DiscountCopy, } from './styles';
function DiscountModal(props) {
    const dialogRef = useRef(null);
    const { modalTitle, modalDiscounts, onClose } = props;
    const stopProp = (ev) => {
        ev.stopImmediatePropagation();
    };
    const backdropClicked = (e) => {
        if (e.target === dialogRef.current) {
            onClose();
        }
    };
    return (_jsx(Notice, { onClose: onClose, containerStyles: { maxWidth: '35.5rem', padding: '2rem 1.5rem 1.5rem' }, children: _jsxs(Content, { children: [_jsx(Title, { children: modalTitle }), _jsx(DiscountList, { children: modalDiscounts.map((discount) => (_jsxs(DiscountItem, { children: [_jsx(DiscountIcon, { children: _jsx("use", { xlinkHref: discount.icon }) }), _jsx(DiscountTitle, { children: discount.title }), _jsx(DiscountCopy, { children: discount.copy })] }))) }), _jsx("button", { onClick: onClose, className: "btn btn--primary", children: "Continue" })] }) })
    // <Wrapper onClick={backdropClicked} className="discount-modal" id="dialog-modal" ref={dialogRef} open>
    //   <Container>
    //     <Content>
    //       <div>
    //         <button onClick={onClose} type="button" className="close">
    //           <svg>
    //             <use xlinkHref="#icon--tooltip-close" />
    //           </svg>
    //         </button>
    //       </div>
    //
    //     </Content>
    //   </Container>
    // </Wrapper>
    );
}
export default DiscountModal;
